





















































































import { NamedCollectionDetail } from '@store/modules/management/collections';
import { MessageBoxInputData } from 'element-ui/types/message-box';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import NewCollectionForm from '../management/NewCollectionForm.vue';
import ShardsComponent from '@components/collection/ShardsComponent.vue';

const Store = namespace('management/collections');

@Component({
  components: {
    ShardsComponent,
    NewCollectionForm,
  },
})
export default class Collections extends Vue {
  private deleteAliasDialogVisible = false;
  private createCollectionDialogVisible = false;
  private aliases: { [alias: string]: string } = {};
  private selectedCollection = '';
  private selectedAlias = '';
  private deletingAlias = false;

  @State private solrMode!: string;

  @Store.State private detailedCollections!: NamedCollectionDetail[];
  @Store.State private loadingDetailedCollections!: boolean;

  @Store.Mutation private setDetailedCollections!: (detailedCollections: NamedCollectionDetail[]) => void;
  @Store.Mutation private setLoadingDetailedCollections!: (loadingDetailedCollections: boolean) => void;

  @Store.Action private loadDetailedCollections!: () => void;

  private get filteredAliases() {
    return Object.keys(this.aliases).filter((k) => this.aliases[k] === this.selectedCollection);
  }

  private shardCountFormatter = (row: NamedCollectionDetail) => {
    return Object.keys(row.shards).length;
  };

  private loadAliases() {
    this.$service.solr.admin.zookeeper
      .zookeeper({
        wt: 'json',
        detail: true,
        path: '/aliases.json',
      })
      .then(
        (res) => {
          this.aliases = JSON.parse(res.data.znode.data || '{}').collection || {};
        },
        () => ({}),
      );
  }

  private reloadCollection(row: NamedCollectionDetail) {
    this.$confirm(`Do you want to reload collection "${row.name}"`, 'Reload Collection')
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Reloading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        this.$service.solr.collections
          .reload(row.name)
          .then(() => {
            this.$notify.success(`Collection "${row.name}" has been reloaded`);
          })
          .finally(() => loading.close());
      })
      .catch(() => ({}));
  }

  private deleteCollection(row: NamedCollectionDetail) {
    this.$confirm(`Do you want to delete collection "${row.name}"`, 'Delete Collection')
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Deleting',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        this.$http.get(`/solr/admin/collections?action=DELETE&name=${row.name}`).then(() => {
          loading.close();
          this.$notify.success(`Collection "${row.name}" has been deleted`);
          this.loadDetailedCollections();
        });
      })
      .catch(() => this.loadDetailedCollections());
  }

  private createAliasForCollection(row: NamedCollectionDetail) {
    this.$prompt('Alias Name', 'Create Alias')
      .then((msgBoxData) => {
        const value = (msgBoxData as MessageBoxInputData).value;
        const loading = this.$loading({
          lock: true,
          text: 'Creating',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        this.$http.get(`/solr/admin/collections?action=CREATEALIAS&name=${value}&collections=${row.name}`).then(
          () => {
            loading.close();
            this.$notify.success(`Alias "${value}" for collection "${row.name}" has been created`);
            this.loadDetailedCollections();
            this.loadAliases();
          },
          () => loading.close(),
        );
      })
      .catch(() => ({}));
  }

  private deleteAliasOfCollection(row: NamedCollectionDetail) {
    this.deleteAliasDialogVisible = true;
    this.selectedCollection = row.name;
  }

  private doDeleteAliasOfCollection() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.$http.get(`/solr/admin/collections?action=DELETEALIAS&name=${this.selectedAlias}`).then(
      () => {
        this.deletingAlias = false;
        this.deleteAliasDialogVisible = false;
        this.$notify.success(`Alias "${this.selectedAlias}" of collection ${this.selectedCollection} is deleted`);
        this.loadAliases();
      },
      () => {
        this.deletingAlias = false;
        this.deleteAliasDialogVisible = false;
        this.loadAliases();
      },
    );
  }

  private done() {
    this.createCollectionDialogVisible = false;
    this.loadDetailedCollections();
  }

  @Watch('solrMode')
  private onSolrModeChanged() {
    this.loadDetailedCollections();
  }

  @Watch('aliases')
  private onAliasesChanged() {
    this.selectedAlias = '';
  }

  created() {
    this.loadDetailedCollections();
    this.loadAliases();
  }
}
